import React from 'react';

export const PermissionCheck = ({ children }) => {
  return <>{children}</>;
};
